<cds-modal-dialog [(isOpen)]="showModal" (isOpenChange)="openChange($event)">
    <div cdsModalInitialFocus
      class="cds-modal-content"
      role="dialog"
      tabindex="0"
    >
        <ng-content></ng-content>
    </div>
</cds-modal-dialog>